import React, { useState, ChangeEvent, FormEvent, useEffect } from "react";
import axios from "axios";
import { Form, FormGroup, Label, Input, Button, Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import { baseUrl } from "../../../../../Utils/Baseurl/Baseurl";

interface CompanyRegistrationProps {
  logoClass?: string;
  closeModal: () => void;
}

export default function CompanyRegistration({
  logoClass,
  closeModal,
}: CompanyRegistrationProps) {
  const [formData, setFormData] = useState({
    companyname: "",
    companyemail: "",
    licenseno: "",
    contactno: "",
    companyaddress: "",
  });

  const [companies, setCompanies] = useState<string[]>([]); // Store company names as an array of strings
  const [isLoading, setIsLoading] = useState(false);

  // Handle the input change for the company name field
  const handleInputChange = async (
    
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });

    if (id === "companyname" && value.length > 1) {
      setIsLoading(true);
      console.log("Fetching company names for:", value);


      try {
        const response = await axios.get(
          `${baseUrl}companydetails/searchCompany`,
          {
            params: { query: value },
          }
        );
        console.log(response, 'res')
        setCompanies(response.data.companies); // Update the company list with matching results

        // Check if the entered company name is already in the suggestions list
        if (response.data.companies.includes(value)) {
          toast.error("Company name is already registered!", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      } catch (error) {
        console.error("Error fetching company names:", error);
        setCompanies([]);
      }

      setIsLoading(false);
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        baseUrl + "companydetails/createCompany",
        formData
      );

      if (response.status === 201) {
        toast.success("Company created successfully!", {
          position: "top-right",
          autoClose: 3000,
        });

        setFormData({
          companyname: "",
          companyemail: "",
          licenseno: "",
          contactno: "",
          companyaddress: "",
        });

        closeModal();
      } else {
        toast.error(response.data.message || "Error creating company", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error: any) {
      console.error("Error:", error);
      toast.error(
        error.response?.data?.message ||
        "Error creating company. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };

  return (
    <div
      className={`container d-flex flex-column align-items-center justify-content-center min-vh-50 ${logoClass || ""
        }`}
    >
      <div className="login-main w-100">
        <Form
          className="theme-form p-4 shadow rounded bg-white"
          onSubmit={handleSubmit}
        >
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Company Name <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  id="companyname"
                  required
                  placeholder="ABC Groups"
                  value={formData.companyname}
                  onChange={handleInputChange}
                />
                {/* Show company name suggestions */}
                {companies.length > 0 && (
                  <ul className="company-suggestions-list">
                    {companies.map((companyName, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          setFormData({
                            ...formData,
                            companyname: companyName,
                          });
                          toast.error("Company name is already registered!", {
                            position: "top-right",
                            autoClose: 3000,
                          });
                          setCompanies([]); // Hide the suggestions after selection
                        }}
                      >
                        {companyName}
                      </li>
                    ))}
                  </ul>
                )}
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>
                  DL No <span style={{ color: "red" }}>*</span>{" "}
                </Label>
                <Input
                  type="text"
                  id="licenseno"
                  required
                  placeholder="1234567890"
                  value={formData.licenseno}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Contact Number <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="tel"
                  id="contactno"
                  required
                  placeholder="1234567890"
                  value={formData.contactno}
                  onChange={handleInputChange}
                  inputMode="numeric"
                  pattern="[0-9]*"
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>
                  Email Address <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="email"
                  id="companyemail"
                  required
                  placeholder="test@gmail.com"
                  value={formData.companyemail}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <FormGroup>
            <Label>
              Company Address <span style={{ color: "red" }}>*</span>
            </Label>
            <Input
              type="textarea"
              id="companyaddress"
              required
              placeholder="Kerala"
              value={formData.companyaddress}
              onChange={handleInputChange}
              className="resize-none"
            />
          </FormGroup>

          <FormGroup className="mb-0 text-center">
            <Button color="primary" className="w-100 mt-3" type="submit">
              Register
            </Button>
          </FormGroup>
        </Form>
      </div>
    </div>
  );
}
